"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getClearedFields = function getClearedFields(formId, baseField) {
  if (!window.fs_mappings) {
    return [];
  }

  if (!window.fs_mappings[formId]) {
    return [];
  }

  if (!window.fs_mappings[formId].drop[baseField]) {
    return [];
  }

  return window.fs_mappings[formId].drop[baseField];
};

exports.default = getClearedFields;


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/utils/getClearedFields.js
// module id = 1127
// module chunks = 5